import React, { useEffect, useRef, useState } from 'react'
import { Grid, Typography, TextField, Paper, Box } from '@mui/material'
import CommonModal from './CommonModal'
import "./AddEditInterfaceModal.css"
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import PaymentStatusModal from './PaymentStatusModal'
import WifiIcon from '@mui/icons-material/Wifi';
import { getDPOProduct, initiateDpoPayment, getDPOAccountAccountInfo, ACTION_TYPES, getDpoPaymentStatus, getServiceLines, cancelDPOTransaction } from "../../../../../components/StarlinkAdmin/slice"
import _ from 'lodash'
import { getDecodeURI } from '../../../../../utils/util'
import { DEFAULT_TIMEZONE } from '../../../../../utils/constants'
import moment from 'moment-timezone'
import TopUpTierCardNew from './TopUpTierCard';

type FlowStatus = | 'IDLE' | 'INITIATED' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED' | 'CANCELLED'


const TopUpModal = (props) => {
    const { open, onClose, serviceLine, serviceLinesDataRaw, location, getDPOProduct, cancelTransaction, newSummaryServiceLine, starlinkDPOProducts, cancelDPOTransaction, getServiceLines, dpIds, getDpoPaymentStatus, selectedOu, initiateDpoPayment, getDPOAccountAccountInfo, dpoPaymentStatus, getDpoAccountInfo, inititeDpoPaymentInfo } = props
    const [selectedProduct, setSelectedProduct] = useState<any>(null)
    const [note, setNote] = useState('')
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch();
    const [paymentStatus, setPaymentStatus] = useState<FlowStatus>('IDLE')
    const [topUpStatus, setTopUpStatus] = useState<FlowStatus>('IDLE')
    const [paymentModalOpen, setPaymentModalOpen] = useState(false)
    const pollingRef = useRef<any>(null)
    const [confirmOpen, setConfirmOpen] = useState(false)
    const params = new URLSearchParams(window.location.search)
    const [serviceLinesData, setLocalServiceLineData] = useState<any>(null)
    const [transactionTokenLocal, setTransactionTokenLocal] = useState<any>("")
    const isSaveDisabled = !selectedProduct || paymentStatus === 'IN_PROGRESS'
    const [quantity, setQuantity] = useState<number>(1)


    useEffect(() => {
        if (serviceLinesDataRaw && serviceLinesDataRaw?.length > 0) {
            setLocalServiceLineData(serviceLinesDataRaw[0])
            getDPOAccountAccountInfo({ dpId: serviceLinesDataRaw[0]?.dpId })
            getDPOProduct({ dpId: serviceLinesDataRaw[0]?.dpId })
        }
        setLoading(false)

    }, [serviceLinesDataRaw])

    useEffect(() => {
        if (!open) return
        setLoading(true)
        if (!_.isEmpty(serviceLine)) {
            getServiceLines({
                accounts: [],
                dpIds,
                searchText: serviceLine?.serviceLineNumber,
                sortBy: "serviceLineName",
                sortOrder: "asc",
                page: 1,
                limit: 10,
                serviceLines: Array.isArray(newSummaryServiceLine) ? newSummaryServiceLine?.filter(sl => sl !== '') : [],
            })
        }

    }, [open, newSummaryServiceLine])

    const handleSave = () => {
        if (!selectedProduct || !getDpoAccountInfo) return

        const url = new URL(window.location.origin + window.location.pathname)

        const params = new URLSearchParams(location.search)

        params.set('topup', 'true')
        params.set('sl', serviceLinesData?.serviceLineNumber || '')
        params.set('companyToken', getDpoAccountInfo?.company_token || '')

        url.search = params.toString()

        const redirectURL = url.toString()
        const backURL = redirectURL

        setLoading(true)

        initiateDpoPayment({
            dpId: serviceLinesData?.dpId,
            companyToken: getDpoAccountInfo?.company_token,
            serviceLineNumber: serviceLinesData?.serviceLineNumber,
            accountNumber: serviceLinesData?.accountNumber,
            notes: note,
            dataAmount: selectedProduct?.dataAmount * quantity,
            dataUnit: 'gb',
            count: quantity,
            redirectURL,
            backURL
        })

    }


    useEffect(() => {
        if (!_.isEmpty(inititeDpoPaymentInfo) && inititeDpoPaymentInfo?.paymentURL && inititeDpoPaymentInfo?.transactionToken) {
            window.open(inititeDpoPaymentInfo.paymentURL, '_blank')
            setPaymentStatus('IN_PROGRESS')
            setConfirmOpen(false)
            setPaymentModalOpen(true)
            setTransactionTokenLocal(inititeDpoPaymentInfo.transactionToken)
            startPolling(inititeDpoPaymentInfo.transactionToken)
            setLoading(false)
        }
    }, [inititeDpoPaymentInfo])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)

        const transactionToken = params.get('TransactionToken')
        const ccdApproval = params.get('CCDapproval')

        if (!transactionToken) return

        const isSuccess = Boolean(ccdApproval)

        if (isSuccess) {
            window.opener?.postMessage(
                { type: 'PAYMENT_COMPLETED', transactionToken },
                window.location.origin
            )

            window.close()
            return
        }

        cancelDPOTransaction({
            dpId: selectedOu?.id,
            transactionToken
        })
    }, [])

    useEffect(() => {
        if (!cancelTransaction) return

        window.opener?.postMessage(
            { type: 'PAYMENT_CANCELLED' },
            window.location.origin
        )

        setTimeout(() => {
            window.close()
        }, 1500)

    }, [cancelTransaction])

    const startPolling = (transactionToken: string) => {
        pollingRef.current = setInterval(async () => {
            getDpoPaymentStatus({
                transactionId: transactionToken
            })
        }, 10000)
    }

    useEffect(() => {
        if (!dpoPaymentStatus?.data) return

        const { paymentStatus, topupStatus } = dpoPaymentStatus.data

        setPaymentStatus(paymentStatus)

        if (paymentStatus === 'COMPLETED') {
            setTopUpStatus(topupStatus)

            if (topupStatus === 'COMPLETED' || topupStatus === 'FAILED') {
                clearInterval(pollingRef.current)
            }
        } else if (paymentStatus === 'FAILED') {
            setTopUpStatus('FAILED')
            clearInterval(pollingRef.current)
        } else if (paymentStatus === 'CANCELLED') {
            setTopUpStatus('CANCELLED')
            clearInterval(pollingRef.current)
        } else {
            setTopUpStatus('IDLE')
        }

        dispatch({
            type: ACTION_TYPES.INITIATE_DPO_PAYMENT,
            payload: []
        })
    }, [dpoPaymentStatus])


    useEffect(() => {
        return () => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current)
            }
        }
    }, [])

    useEffect(() => {
        if (starlinkDPOProducts?.productId) {
            setSelectedProduct(starlinkDPOProducts)
        }
    }, [starlinkDPOProducts])


    const handleClose = () => {
        dispatch({ type: ACTION_TYPES.GET_DPO_PRODUCTS, payload: {} });
        dispatch({  type: ACTION_TYPES.GET_SERVICE_LINES, payload: null  })
        setLocalServiceLineData(null)
        onClose()
    }

    const formatGB = (value: any) => {
        const num = Number(value)
        if (!num || Number.isNaN(num)) return '0'

        return num.toLocaleString(undefined, {
            maximumFractionDigits: 2,
            notation: num >= 1000 ? 'compact' : 'standard'
        })
    }

    const topupList =
        serviceLinesData?.data_block_product_details
            ?.filter(item => item?.product_type === 'topUpProduct')
            ?.slice()
            ?.sort((a, b) =>
            new Date(b?.start_date || 0).getTime() -
            new Date(a?.start_date || 0).getTime()
            ) ?? []


    return (
        <>
            <CommonModal
                open={open}
                onClose={handleClose}
                onSave={() => { setConfirmOpen(true) }}
                title="Top-Up Details"
                saveText={selectedProduct ? `Add ${selectedProduct?.dataAmount * quantity} GB` : 'Select a Tier'}
                disableSave={isSaveDisabled || serviceLinesData === null}
                showLoader={loading}
                showOnlineOffline={false}
                showSyncStatus={false}
                width='500px'
                maxWidth='500px'
            >
                <Box className="modal-scroll-container">
                    <Grid container spacing={3} >

                        <Grid item xs={12}>
                            <Paper elevation={0} className="dpo-topup-summary-card">
                                <Grid container spacing={2} alignItems="center">

                                    <Grid item xs={12}>
                                        <Grid container justifyContent="space-between" alignItems="flex-start">
                                            <Grid item xs>
                                                <Grid container direction="column">
                                                    <Typography fontWeight={600}> {serviceLinesData?.serviceLineName || ""} </Typography>
                                                    <Typography variant="body2" color="text.secondary"> {serviceLinesData?.serviceLineNumber || ""} </Typography>
                                                    <Typography variant="body2" color="text.secondary"> {serviceLinesData?.servicePlan || ""} </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid item>
                                                <span className={`dpo-topup-status-badge ${serviceLinesData?.serviceLineStatus ? 'online' : 'offline'}`} >
                                                    <WifiIcon className={serviceLinesData?.serviceLineStatus ? 'topup-wifi-online' : 'topup-wifi-offline'} />
                                                    {serviceLinesData?.serviceLineStatus ? 'online' : 'offline'}
                                                </span>
                                            </Grid>

                                        </Grid>

                                    </Grid>

                                    <Grid item xs={12}>
                                        <Grid container className="dpo-topup-stats-row">

                                            <Grid item xs={4} className="dpo-topup-stat-col">
                                                <Typography className="dpo-topup-usage-value"> {formatGB(serviceLine?.usageGB) || 0}</Typography>
                                                <Typography className="dpo-topup-stat-label">Usage (GB)</Typography>
                                            </Grid>

                                            <Grid item xs={4} className="dpo-topup-stat-col">
                                                <Typography className="dpo-topup-plan-value">{formatGB(serviceLinesData?.usageLimitGB) || 0}</Typography>
                                                <Typography className="dpo-topup-stat-label">Plan (GB)</Typography>
                                            </Grid>

                                            <Grid item xs={4} className="dpo-topup-stat-col">
                                                <Typography className="topup-value">{serviceLinesData?.data_block_product_details
                                                    ?.filter(item => item?.product_type === 'topUpProduct')
                                                    ?.reduce((sum, item) => sum + ((item?.data_amount ?? 0) * (item?.count ?? 0)), 0) ?? 0}
                                                </Typography>
                                                <Typography className="dpo-topup-stat-label">Top-ups (GB)</Typography>
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                </Grid>

                                {serviceLinesData && (
                                    <Grid item xs={12}>
                                        <Typography paddingTop={1} paddingBottom={2} color="text.secondary">
                                            {
                                                serviceLinesData?.data_block_product_details
                                                    ?.filter(item => item?.product_type === 'topUpProduct')
                                                    ?.length ?? 0
                                            } top-ups purchased
                                        </Typography>

                                        <Grid container paddingTop={1} spacing={1} className="topup-history-container menuScroll">
                                            {topupList?.map((item, index) => (
                                                    <Grid item xs={12} key={index} className="top-up-wrapper">
                                                        <Paper elevation={0} className="topup-history-card">
                                                            <Grid container justifyContent="space-between" alignItems="center">
                                                                <Typography>
                                                                    {item?.count > 1
                                                                        ? `+${item?.data_amount} ${item?.data_unit} * ${item?.count}`
                                                                        : `+${item?.data_amount} ${item?.data_unit}`}
                                                                </Typography>

                                                                <Typography color="text.secondary">
                                                                    {item?.start_date
                                                                        ? moment(item?.start_date).tz(DEFAULT_TIMEZONE).format("MMM DD, YYYY")
                                                                        : ''}
                                                                </Typography>
                                                            </Grid>
                                                        </Paper>
                                                    </Grid>
                                                ))}
                                        </Grid>
                                    </Grid>

                                )}
                            </Paper>
                        </Grid>
                        {starlinkDPOProducts && starlinkDPOProducts?.dataAmount && <>
                            <Grid item xs={12}>
                                <Grid container justifyContent="space-between" alignItems="center">
                                    <Typography > Add New Top-Up </Typography>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4} key={starlinkDPOProducts?.productId}>
                                        <TopUpTierCardNew
                                            dataAmount={starlinkDPOProducts?.dataAmount * quantity}
                                            price={starlinkDPOProducts?.paymentAmount * quantity}
                                            currency={starlinkDPOProducts?.paymentCurrency}
                                            quantity={quantity}
                                            selected={selectedProduct?.productId === starlinkDPOProducts?.productId}
                                            onSelect={() => {
                                                if (selectedProduct?.productId === starlinkDPOProducts?.productId) {
                                                    setSelectedProduct(null)
                                                    setQuantity(1)
                                                } else {
                                                    setSelectedProduct(starlinkDPOProducts)
                                                    setQuantity(1)
                                                }
                                            }}
                                            onQuantityChange={setQuantity}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>}

                        <Grid item xs={12}>
                            <Typography variant="subtitle2" marginBottom={1}>
                                Note (optional)
                            </Typography>

                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                inputProps={{ maxLength: 250 }}
                                placeholder="Add a note for this top-up..."
                            />
                        </Grid>

                    </Grid>
                </Box>
            </CommonModal>

            <PaymentStatusModal
                open={paymentModalOpen}
                paymentStatus={paymentStatus}
                topUpStatus={topUpStatus}
                transactionToken={transactionTokenLocal}
                onClose={() => {
                      getServiceLines({
                          accounts: [],
                          dpIds,
                          searchText: serviceLinesData?.serviceLineNumber,
                          sortBy: "serviceLineName",
                          sortOrder: "asc",
                          page: 1,
                          limit: 10,
                          serviceLines: Array.isArray(newSummaryServiceLine) ? newSummaryServiceLine?.filter(sl => sl !== '') : [],
                      })
                      setQuantity(1)
                    setPaymentModalOpen(false)
                }}
            />

            <CommonModal
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                onSave={handleSave}
                title="Confirm Payment"
                saveText="Proceed to Payment"
                showLoader={loading}
                disableSave={loading}
                showOnlineOffline={false}
                showSyncStatus={false}
            >
                <Grid container direction="column" spacing={2} padding={10}>
                    <Typography>
                        You will be redirected to the secure payment page.
                    </Typography>
                    <Typography color="text.secondary">
                        Please complete the payment.
                    </Typography>
                </Grid>
            </CommonModal>
        </>
    )
}

const mapStateToProps = (state) => ({
    serviceLinesDataRaw: state?.starlinkAdmin?.serviceLines,
    starlinkDPOProducts: state?.starlinkAdmin?.dpoProducts,
    selectedOu: state?.authReducer?.selectedOu,
    getDpoAccountInfo: state?.starlinkAdmin?.getDpoAccountInfo,
    inititeDpoPaymentInfo: state?.starlinkAdmin?.inititeDpoPaymentInfo,
    dpoPaymentStatus: state?.starlinkAdmin?.dpoPaymentStatus,
    cancelTransaction: state?.starlinkAdmin?.cancelTransaction,
    dpIds: state.starlinkCloud.dpIds,
    newSummaryServiceLine: state?.authReducer?.newSummaryServiceLine,
});

export default withRouter(
    connect(mapStateToProps, { getDPOProduct, initiateDpoPayment, getDPOAccountAccountInfo, getDpoPaymentStatus, getServiceLines, cancelDPOTransaction })(TopUpModal)
);